import React from 'react';
import { motion } from 'framer-motion';
import { ReadMore } from './ReadMore';
export function PainPoint() {
  return <section className="py-12 md:py-24 bg-white" data-id="element-152">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-153">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-cream-50 rounded-3xl p-5 md:p-12 shadow-sm border border-cream-200" data-id="element-154">
          <ReadMore preview={<p data-id="element-156">
                Sabés exactamente cómo se siente. El nudo en el estómago empieza
                cuando buscás las llaves. Mirás a tu perro y ya está jadeando,
                siguiéndote como una sombra, o peor, mirándote con esos ojos de
                "por favor, no me dejes".
              </p>} data-id="element-155">
            <div className="space-y-4" data-id="element-157">
              <p data-id="element-158">
                Cerrás la puerta y, antes de llegar al ascensor, escuchás el
                primer aullido. Esa salida que debería ser normal se convierte
                en una tortura mental donde no podés disfrutar de nada porque
                solo pensás en los destrozos o en el humor de tus vecinos.
              </p>
              <p data-id="element-159">
                Vivir así no es vida, ni para vos ni para él. El problema es que
                tu perro no es "malo" ni caprichoso. Su cerebro entró en un
                bucle de pánico de supervivencia donde tu partida equivale al
                fin del mundo.
              </p>
              <p data-id="element-160">
                Y lo que intentaste hasta ahora (dejarle la tele prendida, darle
                un hueso o retarlo al volver) solo ha reforzado su miedo.
                Necesitás romper la estadística del pánico.
              </p>
            </div>
          </ReadMore>
        </motion.div>
      </div>
    </section>;
}